export default "__VITE_ASSET__CANKuANa__"